<template>
  <div id="app">
    <div class="mobile">
      <img src="../src/assets/images/mobile.png" alt="">
      <p>请使用电脑打开此链接或微信搜索“网上开庭客服”小程序</p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'App',
  components: {},
  provide() {
    return {
      reload: this.reload,
      route: ''
    };
  },
  data() {
    return {
      isRouterAlive: true
    };
  },
  mounted() {
    // let href = window.location.href;
    // let query = href.slice(href.indexOf('?'));
    // if (!this.isMobile()) {
    //   window.location.href='https://videos.i-ac.cn/#/'+query
    // }
  },
  methods: {
    reload() {
      // 触发视图view全局更新
      this.isRouterAlive = false;
      this.$nextTick(() => {
        this.isRouterAlive = true;
      });
    },
    isMobile() {
      console.log(navigator.userAgent);
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    }
  }
};
</script>

<style lang="scss">
@import './theme/element-variables.scss';
</style>

<style>
/* 重置样式 */
@import './assets/style/base.css';
/* 公共样式 */
@import './assets/style/global.css';
/* 引入字体 */
@import './assets/fonts/iconfont.css';
</style>

<style>
html,
body {
  height: 100%;
}
#app {
  width: 100%;
  height: 100%;
  margin: 0 auto;
  overflow: hidden;
  background: #ffffff;
  /*user-select: none;*/
}
#app .mobile {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  color: #b1b1b1;
}
#app .mobile img {
  width: 100%;
}
#app .mobile p {
  padding: 20px 40px 0 40px;
  text-align: center;
  line-height: 26px;
  font-size: 15px;
}

.main-content {
  background: #262931;
  min-width: 1000px;
  width: calc(100% - 200px);
  height: calc(100vh - 80px);
  overflow: hidden;
  flex: 1;
}

.container {
  height: 100%;
}

.content {
  height: 100%;
}

.el-message .el-icon-error {
  color: #f43d3c;
}

.el-message--error {
  background-color: #fe7242;
  border-color: #fe7242;
}

.el-message--error .el-message__content {
  color: #ffffff;
}

.el-message--success {
  background-color: #2eda66;
  border-color: #2eda66;
}

.el-message--success .el-message__content {
  color: #ffffff;
}

.el-message .el-icon-success {
  color: #ffffff;
}
</style>
